module.exports = __webpack_public_path__ + "img/logo-white.1278f95f.svg";